import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import showToast from '@/lib/helpers/show-toast';

const LIVE_STATUS_TOAST_ID = 'live-status';

export function useLiveStatus() {
  const { t } = useTranslation();

  useEffect(() => {
    function handleOffline() {
      showToast({
        variant: 'error',
        title: t('common:table.liveBanner.unavailable'),
        options: {
          id: LIVE_STATUS_TOAST_ID,
          duration: Infinity,
          classNames: {
            icon: 'text-destructive',
          },
        },
      });
    }

    function handleOnline() {
      showToast({
        variant: 'success',
        title: t('common:table.liveBanner.restored'),
        options: {
          id: LIVE_STATUS_TOAST_ID,
          duration: 3000,
          classNames: {
            icon: 'text-success',
          },
        },
      });
    }

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, [t]);
}
